import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  useColorMode,
  Icon,
} from '@chakra-ui/react';
import { NavbarWithCallToAction } from './chakra/NavbarWithCallToAction/NavbarWithCallToAction';
import { FooterWithFourColumns } from './chakra/FooterWithFourColumns/FooterWithFourColumns';
import { FaRocket } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { getColor } from '../brandConfig';

interface PlaceholderPageProps {
  title: string;
  description: string;
  category?: string;
}

export const PlaceholderPage: React.FC<PlaceholderPageProps> = ({
  title,
  description,
  category,
}) => {
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  return (
    <>
      <NavbarWithCallToAction />
      <Box
        minH="100vh"
        bg={getColor('background.main', colorMode)}
        color={getColor('text.primary', colorMode)}
        position="relative"
      >
        <Container maxW="900px" py={20}>
          <VStack spacing={8} textAlign="center" mb={20}>
            {category && (
              <Text
                sx={{
                  color: getColor('primary', colorMode),
                  letterSpacing: '0.13em',
                  textTransform: 'uppercase',
                  backgroundColor: `${getColor('primary', colorMode)}20`,
                  borderRadius: '50em',
                  padding: '0.7em 1.3em',
                  fontSize: '0.75em',
                  fontWeight: 500,
                  boxShadow: `0 4px 20px ${getColor('primary', colorMode)}50`,
                }}
              >
                {category}
              </Text>
            )}

            <Heading
              size="2xl"
              color={getColor('text.primary', colorMode)}
            >
              {title}
            </Heading>

            <Text
              fontSize="xl"
              color={getColor('text.secondary', colorMode)}
              maxW="2xl"
            >
              {description}
            </Text>

            <Box
              p={8}
              borderRadius="xl"
              border="2px dashed"
              borderColor={getColor('primary', colorMode)}
              bg={`${getColor('primary', colorMode)}10`}
              mt={8}
            >
              <VStack spacing={4}>
                <Icon as={FaRocket} boxSize={12} color={getColor('primary', colorMode)} />
                <Heading size="md" color={getColor('text.primary', colorMode)}>
                  Coming Soon
                </Heading>
                <Text color={getColor('text.secondary', colorMode)} maxW="lg">
                  We're working hard to bring you this content. Check back soon for updates!
                </Text>
                <Button
                  mt={4}
                  bg={getColor('primary', colorMode)}
                  color="white"
                  _hover={{
                    bg: getColor('primaryHover', colorMode),
                    transform: 'translateY(-2px)',
                  }}
                  onClick={() => navigate('/')}
                >
                  Back to Home
                </Button>
              </VStack>
            </Box>
          </VStack>
        </Container>
      </Box>
      <FooterWithFourColumns />
    </>
  );
};
